<template>
    <div>
        <div class="form-group">
            <label for="">Kontokorrentrahmen</label>
            <input type="number" class="form-control" min="0" step="1000" v-model="konto">
        </div>

        <app-rangeSlider 
            :minVal="0" 
            :maxVal="maxVal" 
            :val="konto" 
            :dynamic="dynamic"
            :step="1"
            >
            <template v-slot:minval>{{ minVal }} €</template>
            <template v-slot:maxval>{{ formatNumber(maxVal) }} €</template>
        </app-rangeSlider>

        <div class="form-group mt-2">
            <label for="">Sollzinssatz (in %)</label>
            <input class="form-control" type="number" min="0" step="0.1" v-model="sollzins">
        </div>
    </div>
</template>

<script>
import RangeSlider from "./RangeSlider";
import {numberMixin} from "../mixins/numberMixin"

export default {
    mixins: [numberMixin],
    data: function () {
        return {
            minVal: 0,
            maxVal: 1000000,
            dynamic: "Konto" //dynamic gibt an, ob der Kreditrahmen oder Kontokorrentrahmen geupdated werden soll
        }
    },
    components: {
        'app-rangeSlider': RangeSlider
    },
    computed: {
        konto: {
            get () {
                return this.$store.getters.getKonto
            },
            set(value) {
                this.$store.commit('updateKonto', value)
            }
        },
        sollzins: {
            get() {
                return this.$store.getters.getSollzins
            },
            set (value) {
                this.$store.commit('updateSollzins', value)
            }
        }
    }
}
</script>